/** Apply what `/api/me` says about the user's environment: timezone, language, theme. */
import type { Me } from '@/lib/api/types';
import { setDisplayTimeZone } from '@/lib/format';
import { initialLocale, setLocale } from '@/lib/i18n';
import { getThemePref, setThemePref } from '@/lib/theme';

let applied: string | null = null;

export function applyMe(me: Me): void {
  setDisplayTimeZone(me.company?.timezone);
  const key = `${me.user.id}|${me.company?.id}`;
  if (applied === key) return;
  applied = key;
  let storedLocale = false;
  try {
    storedLocale = !!localStorage.getItem('nova.locale');
  } catch {
    /* private mode */
  }
  if (!storedLocale) setLocale(initialLocale(me.user.preferences.locale ?? me.user.locale));
  const theme = me.user.preferences.theme;
  if (getThemePref() === 'system' && (theme === 'light' || theme === 'dark')) setThemePref(theme);
}

/** The persona's landing path (server personas use this app's routes). */
export function landingPath(me: Me | undefined): string {
  return me?.persona.landing ?? '/';
}
